import { GlobalStore as store, showGlobalNotification } from '@driftt/traffic-control'

const enableFollowNotification = toggleFollow => ({
  body: 'Get notified when one of your targeted accounts is on your website',
  type: 'blue-button',
  actions: [
    {
      title: 'Enable account notifications',
      action: async (close) => {
        await toggleFollow(true)
        close()
      }
    },
    {
      title: 'Don\'t remind me',
      action: (close) => {
        window.localStorage.setItem('dontRemindAccountFollowNotifications', true)
        close()
      }
    }
  ]
})

export const remindAccountNotifications = async toggleFollow => {
  const dontRemindMe = !!window.localStorage.getItem('dontRemindAccountFollowNotifications')

  if (Notification.permission === "granted" && !dontRemindMe) {
    return store.dispatch(showGlobalNotification(enableFollowNotification(toggleFollow)))
  }
}
